<template>
  <div class="centerIntro-wrap">
    <div class="centerIntro-content">
       <div class="title">{{title}}</div>
       <div class="content" v-html="dataNew.content">
       </div>
       <div class="content" v-if='dataNew.content2' v-html="dataNew.content2"></div>
    </div>
  </div>
</template>

<script>
// import Breadcrumb from '@/components/common/Breadcrumb'
// import { getCurrentCrumb } from '@/utils/crumb.js'
import { fakeData } from '../configs/hotNews'
export default {
  data() {
    return {
      fakeData,
      // crumbOptions: [],
      dataNew: {},
      title: ''
    }
  },
  created() {
    console.log(this.$route)
    const { id, name} = this.$route.query
    this.title = name
    this.dataNew = this.fakeData[id - 1]
    // this.settingCrumb()
  },
  components: {
    // Breadcrumb
  },
  methods: {
    //  settingCrumb() {
    //   const { path } = this.$route
    //   console.log(path);
    //   const crumbOptions = getCurrentCrumb(path)
    //   this.crumbOptions = crumbOptions
    // },
  }
}
</script>

<style>

</style>
